import React from "react";
import StatCard from "../component/aboutMe/StatCard";
import NowSection from "../component/aboutMe/now";
import OriginStory from "../component/aboutMe/originStory";
import QuoteBlock from "../component/aboutMe/quoteBlock";
import Timeline from "../component/aboutMe/Timeline";
import themeLarge from "../component/ThemeLarge";

class AboutMe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileView: window.innerWidth <= 1100,
    };
  }

  updateWindowSize = () => {
    this.setState({
      windowSize: window.innerWidth,
    });
  };

  componentDidMount() {
    window.addEventListener("resize", this.updateWindowSize);
    this.updateWindowSize();
  }

  // Remove event listener when the component unmounts to avoid memory leaks
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  render() {
    const { isMobileView } = this.state;
    return (
      <div
        className="container-fluid"
        style={{
          marginTop: isMobileView ? "0px" : "75px",
          minHeight: "100vh",
          background: themeLarge.colors.bg,
        }}
      >
        <StatCard />

        {/* <OriginStory /> */}

        <Timeline />

        {/* <QuoteBlock /> */}
      </div>
    );
  }
}

export default AboutMe;
